import { initContract } from '@ts-rest/core';
import { ApiErrorSchema } from '../schemas/common';
import {
  SubmitFeedbackRequestSchema,
  SubmitFeedbackResponseSchema,
} from '../schemas/feedback';
import { defaultErrorResponses } from './errors';

const c = initContract();

/**
 * Feedback Contract (#707) - first-party product feedback capture.
 *
 * Authenticated only: anonymous feedback is out of scope and would turn this
 * into an abuse vector. Unlike the PostHog-backed survey it replaces, this
 * endpoint requires no analytics consent and no third-party network call.
 */
export const feedbackContract = c.router({
  submitFeedback: {
    method: 'POST',
    path: '/v1/feedback',
    body: SubmitFeedbackRequestSchema,
    responses: {
      201: SubmitFeedbackResponseSchema,
      429: ApiErrorSchema,
      ...defaultErrorResponses,
    },
    metadata: {
      auth: true,
      summary: 'Submit product feedback',
      description: "Records a signed-in user's free-text product feedback for a given surface.",
    },
  },
});
